import { Box } from "@mui/material";
import React from "react";
import styles from "./deleteDealer.module.scss";
import { ReactComponent as AlertIcon } from "../../../../assets/icons/alert.svg";
import Button from "../../../../components/buttons/Buttons";
import PropTypes from "prop-types";

const DeleteCertificate = (props) => {
  const { handleDelete, handleCancel, primaryMessage, secondaryMessage} = props;

  return(
    <Box
      className={styles.deleteCertificateWrapper}
      data-testid="deleteCertificate"
    >
      <Box className={styles.alertIcon}>
        <AlertIcon />
      </Box>
      <Box className={styles.contentWrapper}>
        <Box className={styles.description}>
          {primaryMessage}
        </Box>
        <Box className={styles.content}>
          {secondaryMessage}
        </Box>
      </Box>

      <Box></Box>
      <Box className={styles.buttonWrapper}>
        <Button
          title="Don't delete"
          iconStyle={""}
          buttonType="muibtn-secondary"
          withIcon={false}
          handleClick={handleCancel}
        />
        <Button
          title="Yes, delete"
          iconStyle={""}
          buttonType="muibtn-primary"
          withIcon={false}
          handleClick={() => handleDelete()}
        />
      </Box>
    </Box>
  ) ;
};
export default DeleteCertificate;

DeleteCertificate.propTypes = {
  handleDelete:PropTypes.any, 
  handleCancel:PropTypes.any,
  primaryMessage: PropTypes.any,
  secondaryMessage: PropTypes.any
}